import { Icon, Text } from '@fluentui/react';
import { t } from 'i18next';

const STATUS_CONFIG: Record<string, string> = {
  REGISTRADO: 'text-icon color-initial',
  PENDIENTE: 'text-icon color-inProcess',
  PRELIQUIDADO: 'text-icon color-inProcess',
  ACEPTADO: 'text-icon color-finished',
  ELIMINADO: 'text-icon color-inactive',
  REPROCESAR: 'text-icon color-inProcess',
  PROCESANDO: 'text-icon color-inProcess',
  ERROR: 'text-icon color-error',
};

export const LiquidacionEstado: React.FC<{ status: string }> = ({ status }) => {
  const className = STATUS_CONFIG[status] ?? 'text-icon color-initial';

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <div>
        <Icon iconName="CircleShapeSolid" aria-label={status} title={t(status)} className={className} />
      </div>
      <Text>{t(status)}</Text>
    </div>
  );
};
